export const API_BASE_URL = 'https://apigatekeeper.cloudgentechnologies.com/api';
// export const API_BASE_URL = 'http://127.0.0.1:8000/api';

export const AUTH_STORAGE_KEY = 'trueface_auth';

export default API_BASE_URL;

